<div class="col-12  ">
  <ngb-alert type="danger" [dismissible]="true"  class="mt-2"  (close)="fecheMensagemErro()"  *ngIf="mensagemErro">
    <i class="k-icon k-i-error "></i> {{mensagemErro}}
  </ngb-alert>
</div>

<form id="frm" [ngClass]="{'needs-validation': !frm.submitted, 'was-validated': frm.submitted}"
      novalidate #frm="ngForm" data-pagarmecheckout-form>
  <div class="bloqueio" *ngIf="carregando" >
    <div class="k-icon k-i-loading mt-5 centralizado fa-2x"  ></div>
  </div>
  <div class="row">
    <div class="col-12 col-sm-8">
      <div class="form-group ">
        <label for="numero">Número do cartão</label>

        <input type="text" class="form-control input-background" autocomplete="off"  [mask]="'0000-0000-0000-0009'" style="font-family: monospace;"
               id="numero" name="numero" [(ngModel)]="cartao.numero" #numero="ngModel" #numeroElem appAutoFocus
               required (ngModelChange)="alterouNumeroCartao()"  data-pagarmecheckout-input>


        <i class="fa fa-credit-card fa-2x" *ngIf="!paymentMethod"
           [ngClass]="{ 'text-muted': !cartao.bandeira,  ' text-success': cartao.bandeira && cartao.numeroValido}" > </i>


        <div class="invalid-feedback">
          <p *ngIf="numero.errors?.required">Obrigatório</p>
          <p *ngIf="numero.errors?.mask">Número do cartão de crédito inválido.</p>
        </div>
      </div>
    </div>

    <div class="col-12 col-sm-4">
      <div class="form-group ">
        <label for="validade">Data validade</label>
        <kendo-dateinput name="validade" id="validade" format="MM/yyyy" class="form-control"  required #validade="ngModel"
                         [(ngModel)]="cartao.validade" data-pagarmecheckout-input>

        </kendo-dateinput>
        <div class="invalid-feedback">
          <p *ngIf="validade.errors?.required">Obrigatório</p>
        </div>
      </div>
    </div>

    <div class="col-12 col-sm-8">
      <div class="form-group ">
        <label for="nome">Nome do titular (como está gravado no cartão)</label>
        <input type="text" class="form-control" autocomplete="off" required data-pagarmecheckout-input
               id="nome" name="nome" [(ngModel)]="cartao.nome" #nome="ngModel"
               placeholder="Nome impresso" value="" >
        <div class="invalid-feedback">
          <p *ngIf="nome.errors?.required">Obrigatório</p>
        </div>
      </div>
    </div>

    <div class="col-12 col-sm-4">
      <div class="form-group ">
        <label for="cvv">Código de segurança</label>
        <input type="text" class="form-control" autocomplete="off" [mask]="'0009'" placeholder="cod. segurança"
               id="cvv" name="cvv" [(ngModel)]="cartao.cvv" #cvv="ngModel" data-pagarmecheckout-input
               required    >
        <div class="invalid-feedback">
          <p *ngIf="cvv.errors?.required">Obrigatório</p>
        </div>
      </div>
    </div>

    <div class="col-12 col-sm-5">
      <div class="form-group">
        <label for="nome">CPF</label>
        <input type="text" class="form-control" autocomplete="off" required data-pagarmecheckout-input
               id="cpf" name="cpf" [(ngModel)]="cartao.cpf" #cpf="ngModel"
               mask="000.000.000-00" cpfValido placeholder="___.___.___-__" value="">
        <div class="invalid-feedback">
          <p *ngIf="cpf.errors?.required">Obrigatório</p>
          <p *ngIf="cpf.errors?.cpfInvalido">CPF é invalido</p>
        </div>
      </div>
    </div>

   <div class="form-group  col-12 col-sm-7">
      <label for="nome">Email</label>
      <input kendoTextBox id="email" name="email" placeholder="Informe seu email"
             class="form-control"   #email="ngModel"
             [(ngModel)]="cartao.email" required/>

      <div class="invalid-feedback">
        <p *ngIf="email.errors?.required">Email é obrigatório</p>
      </div>
    </div>

    <div class="form-group  col-12   " *ngIf="parcelasValores.length">
      <label  >Número de parcelas</label>
      <kendo-combobox   class="form-control" name="parcelas"  [textField]="'descricao'" [valueField]="'id'" required
                        [(ngModel)]="parcela" [data]="parcelasValores"   placeholder="Selecione a quantidade de parcelas"     >
      </kendo-combobox>
    </div>

  </div>


</form>


